import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import OneApiImage from './OneApiImage'

const copy = {
  heading: `One API. Cleaner code.`,
  description: `Our analytics API makes collecting data simple. Reduce all of your tracking code and advertising tags into a single API.`,
}

const OneApi = () => (
  <SectionBase variant="2Col" copyVariant="narrow" reverse={true}>
    <Section.Copy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading>{copy.heading}</CopyText.Heading>
        <CopyText.Description>{copy.description}</CopyText.Description>
      </CopyTextBase>
    </Section.Copy>
    <Section.Contents>
      <OneApiImage />
    </Section.Contents>
  </SectionBase>
)

export default OneApi
